module.exports = __webpack_public_path__ + "media/images/posts/happy-wedding-c13519aa02af78aa67a9ad4066c06912.jpg";